module.exports = __webpack_public_path__ + "1_0_65/img/share_black.5b09112e.svg";